/* global console */

/**
 * This function updates both Gridd and Stylesheet data from old state where
 * data visualization and status color objects are separate from the colors object.
 * This separation was not intended and broke several functionalities, especially
 * the automatic update of linked colors were unable to operate this way.
 * After this update:
 * - switching stylesheets will update the sequential/divergent/status colors too,
 * - changing a sequential/divergent/status color in stylesheet editor will update
 *   the color as appropriate after "Apply" was hit
 * @param {object} gridd Parsed Gridd slice data
 * @param {object} stylesheets Parsed stylesheet slice data
 * @returns object { gridd, stylesheets }
 */
export function upgradeColors(gridd, stylesheets) {
  console.log("Start upgrading Gridd and Stylesheet - colors data structure");

  const colorMap = {};

  if (stylesheets.sheets) {
    Object.keys(stylesheets.sheets).forEach((stylesheetId) => {
      const sheet = stylesheets.sheets[stylesheetId];
      console.log(`Parsing ${stylesheetId}`, sheet);

      if (!sheet.colors) {
        console.log(`Sheet ${stylesheetId} has no colors array, skipping`);
        return;
      }

      let alreadyUpdated = false;
      // if colors were already updated, skip this step
      if (sheet.colors.find((color) => color.name === "sequential1")) {
        console.log(`Sheet ${stylesheetId} was parsed before, skipping`);
        alreadyUpdated = true;
      }

      // collecting general colors
      sheet.colors.forEach((color) => {
        colorMap[color.value] = color.name;
      });

      // parsing sequentials
      sheet.dataVisualizationColors?.sequential?.forEach((color, i) => {
        const name = `sequential${i + 1}`;
        if (!alreadyUpdated) sheet.colors.push({ name, value: color });
        colorMap[color] = name;
      });

      // parsing diverging
      sheet.dataVisualizationColors?.diverging?.forEach((color, i) => {
        const name = `diverging${i + 1}`;
        if (!alreadyUpdated) sheet.colors.push({ name, value: color });
        colorMap[color] = name;
      });

      // parsing status colors
      sheet.statusColors?.forEach((color) => {
        if (!alreadyUpdated) sheet.colors.push(color);
        colorMap[color.value] = color.name;
      });
    });
  }

  if (gridd.cellStyles) {
    // parse Gridd and add colorNames where it matches
    // iterate on all cell styles
    console.log("Intermediate color map", { colorMap });
    Object.keys(gridd.cellStyles)
      .filter((key) => key !== "global" && key !== "assets" && key !== "shapeGroups")
      .forEach((key) => {
        const cellStyle = gridd.cellStyles[key];

        const colorName = colorMap[cellStyle.color];
        if (colorName) cellStyle.colorName = colorName;

        const backgroundName = colorMap[cellStyle.background];
        if (backgroundName) cellStyle.backgroundName = backgroundName;

        const shapeColorName = colorMap[cellStyle.shape?.color];
        if (shapeColorName) cellStyle.shape.colorName = shapeColorName;

        const shapeOutlineColorName = colorMap[cellStyle.shape?.outlineColor];
        if (shapeOutlineColorName) cellStyle.shape.outlineColorName = shapeOutlineColorName;

        const iconColorName = colorMap[cellStyle.icon?.color];
        if (iconColorName) cellStyle.icon.colorName = iconColorName;
      });
  }

  return { gridd, stylesheets };
}
